<template>
  <div v-if="visible">
    <van-overlay z-index="9998" :show="visible"/>
    <van-loading class="full-screen-loading" size="50" color="#FFDB43"/>
  </div>
</template>

<script>
import {Overlay, Loading} from 'vant';

export default {
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.full-screen-loading {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
